export default {
  _enterCredentials: 'na Plataforma Núcleo P.',
  _securityFooter: 'da Núcleo P.',
  product: 'Núcleo P',
  invalidParameters: 'Parâmetros inválidos',
  emailRequired: 'E-mail obrigatório',
  userFallback: 'Usuário',
  unavailable: 'indisponível',
  locationUnavailable: 'Localização indisponível',
  browserUnknown: 'Navegador não identificado',
  securityContext: 'Segurança da conta',
  identityVerificationContext: 'Verificação de identidade',
  greeting: 'Olá, {name}!',
  signoff: 'Equipe {productName}',
  ipAddressLabel: 'Endereço IP',
  locationLabel: 'Local aproximado',
  browserLabel: 'Navegador',
  dateTimeLabel: 'Data e hora',
  verificationCodeLabel: 'Código de verificação',
  verificationCodeHint: 'Este código expira em {minutes} minutos.',
  verificationWarning: 'Se você não iniciou esta solicitação, ignore este e-mail e não compartilhe o código.',
  passwordCreatedSubject: 'Sua senha foi criada',
  passwordChangedSubject: 'Sua senha foi alterada',
  passwordCreatedText: 'Olá, {name}! Sua senha foi criada com sucesso em {dateTime}. Atenciosamente, Equipe {productName}.',
  passwordChangedText: 'Olá, {name}! A senha da sua conta foi alterada em {dateTime}. Se não foi você, altere sua senha imediatamente. Atenciosamente, Equipe {productName}.',
  passwordCreatedTitle: 'Senha criada',
  passwordChangedTitle: 'Senha alterada',
  passwordCreatedLead: 'Sua senha foi criada com sucesso em {dateTime}.',
  passwordChangedLead: 'Sua senha foi alterada em {dateTime}.',
  passwordChangedWarning: 'Se não foi você, altere sua senha imediatamente e revise suas configurações de segurança.',
  passwordChangeAttemptSubject: 'Tentativa de alteração de senha',
  passwordChangeAttemptTitle: 'Tentativa de alteração de senha',
  passwordChangeAttemptText: 'Olá, {name}! Detectamos uma tentativa de alterar a senha da sua conta em {dateTime}, mas a senha atual informada estava incorreta. IP: {ipAddress}. Local aproximado: {location}. Navegador: {browserInfo}. Se não foi você, revise suas sessões e altere sua senha imediatamente.',
  passwordChangeAttemptLead: 'Detectamos uma tentativa de alterar a senha da sua conta em {dateTime}, mas a senha atual informada estava incorreta.',
  passwordChangeAttemptWarning: 'Se não foi você, revise suas sessões e altere sua senha imediatamente.',
  newDeviceSubject: 'Novo dispositivo conectado',
  newDeviceTitle: 'Novo dispositivo conectado',
  newDeviceLead: 'Detectamos um novo dispositivo conectado à sua conta.',
  newDeviceText: 'Detectamos um novo dispositivo conectado à sua conta.\n\nData/hora: {when}\nLocal aproximado: {location}\nIP: {ipAddress}\nNavegador: {browserInfo}\n\nSe não foi você, altere sua senha imediatamente.',
  newDeviceWarning: 'Se não foi você, altere sua senha imediatamente e revise suas sessões ativas.',
  firstAccessSubject: 'Criação de senha Núcleo P',
  firstAccessText: 'Olá, {name}! Este é o código para criar sua senha: {code}. O código é válido por {minutes} minutos. Atenciosamente, Equipe {productName}.',
  firstAccessTitle: 'Criação de senha',
  firstAccessLead: 'Use o código abaixo para criar sua senha.',
  resetSubject: 'Recuperação de senha Núcleo P',
  resetText: 'Seu código para redefinir a senha é {code}. Ele expira em {minutes} minutos.',
  resetTitle: 'Recuperação de senha',
  resetLead: 'Use o código abaixo para redefinir sua senha.',
  mfa: {
    errors: {
      invalidParameters: 'Parâmetros inválidos',
      userNotFound: 'Usuário não encontrado',
      unsupportedMethod: 'Método não suportado',
    },
    email: {
      subject: 'Código de verificação - {productName}',
      text: 'Seu código de verificação é {code}. Ele expira em {minutes} minutos.',
      context: 'Verificação de identidade',
      title: 'Código de verificação',
      lead: 'Use o código abaixo para concluir seu acesso.',
      codeLabel: 'Código de verificação',
      codeHint: 'Este código expira em {minutes} minutos.',
      warning: 'Não compartilhe este código. Se você não iniciou esta solicitação, ignore este e-mail.',
      signoff: 'Equipe {productName}',
    },
  },
};
